
// @ts-nocheck


export const localeCodes =  [
  "ko",
  "en"
]

export const localeLoaders = {
  ko: [
    {
      key: "locale_ko_46json_1138a5b2",
      load: () => import("#nuxt-i18n/1138a5b2" /* webpackChunkName: "locale_ko_46json_1138a5b2" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_15439c70",
      load: () => import("#nuxt-i18n/15439c70" /* webpackChunkName: "locale_en_46json_15439c70" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: true
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "ko",
      iso: "ko-KR",
      files: [
        "/home/runner/work/guardiann-homepage/guardiann-homepage/i18n/ko.json"
      ]
    },
    {
      code: "en",
      iso: "en-US",
      files: [
        "/home/runner/work/guardiann-homepage/guardiann-homepage/i18n/en.json"
      ]
    }
  ],
  defaultLocale: "ko",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_and_default",
  lazy: true,
  langDir: "../i18n",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: true,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: false
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "ko",
    iso: "ko-KR",
    files: [
      {
        path: "/home/runner/work/guardiann-homepage/guardiann-homepage/i18n/ko.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    iso: "en-US",
    files: [
      {
        path: "/home/runner/work/guardiann-homepage/guardiann-homepage/i18n/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/